import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#828282",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.48 43a1.43 1.43 0 01-.663-.163L24 37.177l-10.817 5.66a1.43 1.43 0 01-1.5-.108 1.415 1.415 0 01-.567-1.387l2.066-11.988-8.752-8.49a1.413 1.413 0 01-.36-1.453 1.423 1.423 0 011.15-.965l12.094-1.749L22.723 5.79c.24-.484.735-.79 1.277-.79.542 0 1.038.306 1.278.79l5.408 10.907 12.094 1.75c.537.077.983.45 1.15.964a1.413 1.413 0 01-.36 1.454l-8.752 8.49 2.066 11.987a1.415 1.415 0 01-.567 1.387c-.248.18-.542.271-.837.271zM8.486 20.84l7.22 7.004c.337.326.49.795.41 1.255l-1.704 9.891 8.925-4.67c.415-.217.91-.217 1.326 0l8.925 4.67-1.705-9.89c-.079-.46.074-.93.41-1.256l7.22-7.004-9.978-1.443a1.424 1.424 0 01-1.072-.776L24 9.62l-4.462 9a1.424 1.424 0 01-1.073.776L8.486 20.84z"
  })));
}

export { SvgStarIcon as default };
